<template>
  <div id="buzz-app">
    <CookieConsent />
    <router-view/>
  </div>
</template>

<script>
import CookieConsent from '@/components/CookieConsent.vue'

export default {
  data () {
    return {
    }
  },
  components: {
    CookieConsent
  },
  props: {},
  watch: {},
  created () {},
  mounted () {},
  computed: {},
  methods: {
  }
}
</script>

<style lang="scss">
@import '@/styles/utilities.scss';
@import '@/styles/bs-grid';

.app-loader{
  display: flex;
  height: 100vh;
  width: 100vw;
  color: #51779B;
}

body{
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  margin: 0;
}
p{
  color: #263849;
}
.fixed-width-container{
  max-width: 720px;
  width: 100%;
}
.fixed-width-text{
  max-width: 600px;
  width: 100%;
}
button{
  cursor: pointer;
  outline: none;
}
button.buzz-btn, a.buzz-btn{
  display: inline-block;
  text-decoration: none;
  padding: 20px 32px;
  background-color: #51779B;
  border: none;
  box-shadow: 0 8px 16px 0 rgba(81,119,155,0.4);
  color: #fff;
  border-radius: 40px;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
  &.start-over{
    background-color: #EB1939;
  }
  &.mini-btn{
    padding: 12px 16px;
    font-size: 12px;
  }
  &.email-submit-btn{
    min-width: 180px;
  }
}
button.buzz-link-btn{
  text-decoration: underline;
  color:#51779B;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  font-size: 16px;
  line-height: 20px;
  display: inline-block;
  &.close-btn{
    color:#7f8d9b;
    text-decoration: none;
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 32px;
    line-height: 20px;
  }
}
#buzz-app{
  .vue-slider-dot-handle{
    background-color: #51779B;
  }
  .vue-slider-rail{
    background-color: #DEE6ED;
  }
  .vue-slider-process{
    background-color: #51779B;
  }
  .vue-slider-mark-step, .vue-slider-mark-step-active{
    background-color: #51779B;
  }
  .vue-slider-dot-handle::after{
    background-color: rgba(#51779B, 0.38)
  }
  .vue-slider-mark-label, .vue-slider-mark-label-active{
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    color: #51779B;
    font-family: 'Roboto', sans-serif;
  }
  .vue-slider-ltr .vue-slider-mark-label{
    margin-top: 16px;
    text-align: center;
  }
  .vue-slider-mark:first-of-type .vue-slider-mark-label{
    left: -8px;
    -webkit-transform: none;
    transform: none;
    text-align: left;
  }
  .vue-slider-mark:last-of-type .vue-slider-mark-label{
    left: auto;
    right: -8px;
    -webkit-transform: none;
    transform: none;
    text-align: right;
  }
  .force-wrap{
    .vue-slider-mark-label, .vue-slider-mark-label-active{
      white-space: normal;
    }
  }
}
input[type=text],
input[type=tel],
input[type=number],
input[type=email] {
  // height: 48px;
  padding: 12px;
  border: solid 1px #51779B;
  border-radius: 2px;
  font-size: 18px;
  font-weight: 300;
  color: #51779B;
  background-color: #fff;
  &::placeholder{
    color: #CAC7C7
  }
  &.has-error{
    border-color: #e60000;
  }
}
.input-prefix{
  display: inline-block;
  margin-right: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #66686A;
}
.input-unit-label{
  display: inline-block;
  margin-left: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #66686A;
}
.required-astrix{
  color: red;
}
.speech-bubble {
  position: relative;
  background: #51779B;
  border-radius: 8px;
  padding: 16px;
  max-width: 100%;
  min-height: 80px;
  color: #fff;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 16px solid transparent;
    border-top-color: #51779B;
    border-bottom: 0;
    border-left: 0;
    margin-left: -16px;
    margin-bottom: -16px;
  }
}
//info-pages
.back-container{
  margin-bottom: 40px;
}
a.back-button{
  text-decoration: none;
  color: #3872B0;
  font-size: 16px;
  font-weight: 500;
}
.info-page{
  padding: 68px 24px 0px;
  h1{
    font-size: 24px;
    text-align: center;
    font-weight: 500;
    color: #3872B0;
  }
  p{
    font-size: 16px;
    line-height: 24px;
    margin: 0px;
    margin-bottom: 24px;
    &:last-of-type{
      margin-bottom: 12px;
    }
  }
  .quote{
    border-left: solid 4px #51779B;
    padding-left: 12px;
  }
  .quote-byline{
    text-align: right;
    a {
      color: #15C;
    }
  }
  img.info-img{
    width: 100%;
    height: auto;
  }
  h2{
    font-size: 18px;
    font-weight: 500;
    color: #3872B0;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
}
ul.reset,
ul.reset li,
ul.reset ul li {
  margin:0;
  padding: 0;
  text-indent: 0;
  list-style-type: none;
}
h1{
  font-size: 24px;
  font-weight: 500;
  color: #3872B0;
  text-transform: uppercase;
  margin-bottom: 20px;
}
.text-bold{
  font-weight: bold;
}

//Calculator Styles
.buzz-calc{
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  .home-main-content{
    position: relative;
  }
  .buzz-header{
    position: relative;
    margin-bottom: 40px;
    a.hero-home-link{
      display: block;
      text-decoration: none;
    }
    img.ask-buzz-hero{
      width: 140px;
      position: relative;
    }
    a.more-reading-link{
      display: block;
      text-decoration: none;
      position: absolute;
      right: -12px;
      top: -4px;
      img.more-reading-img{
        width: 200px;
      }
    }
  }
  .speech-bubble{
    width: 160px;
    top: -12px;
    left: 24px;
    font-size: 18px;
  }
  .width-30{
    width: 30%;
  }
  h2, .h2{
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    color: #2E4357;
    font-family: 'Roboto', sans-serif;
    display: block;
    margin: 0;
  }
  h3, .h3{
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    text-transform: uppercase;
    color: #51779B;
    font-family: 'Roboto', sans-serif;
    display: block;
    margin: 0;
    margin-bottom: 8px;
  }
  .form-results-container{
    padding-right: 24px;
    padding-top: 24px;
  }
  .main-form h2, .main-form .h2{
    margin-bottom: 16px;
    &.has-desc{
      margin-bottom: 6px;
    }
  }
  .question-description{
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #66686A;
    margin: 0;
    max-width: 600px;
  }
  .attendance-input{
    width: 100%;
    max-width: 280px;
  }
  .small-input-with-units{
    width: 100%;
    max-width: 120px;
    text-align: right;
  }
  .small-input{
    width: 100%;
    max-width: 120px;
  }
  p.error-flag{
    padding: 0;
    margin-top: 8px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    color: #e60000;
  }
  .results-header{
    justify-content: flex-start;
    .edit-input-button{
      height: 20px;
    }
  }
  .main-results h2, .main-results .h2{
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 8px;
  }
  .result-group{
    margin-bottom: 48px;
  }
  .result-answer, .attendance-value{
    font-size: 36px;
    line-height: 40px;
    font-weight: 500;
    color: #51779B;
    margin-bottom: 8px;
  }
  .attendance-value{
    color: #2E4357;
  }
  .result-description, p.result-description{
    font-size: 16px;
    font-weight: 400;
    color: #66686A;
    margin: 0;
    max-width: 600px;
  }
  .more-questions-header{
    font-size: 18px;
    color: #51779B;
    font-weight: 500;
    text-align: center;
    margin: 12px 0px 60px;
  }
  .more-questions-circles{
    position: relative;
    height: 520px;
  }
}
// media queries -at and up-
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .buzz-calc{
    .buzz-header{
      margin-bottom: 60px;
      img.ask-buzz-hero{
        width: 220px;
      }
      a.more-reading-link{
        right: 0px;
        top: -4px;
        img.more-reading-img{
          width: 260px;
        }
      }
    }
    .more-questions-circles{
      height: 660px;
    }
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .info-page{
    padding: 0px 0px;
  }
  .buzz-calc .form-results-container{
    padding-right: 0px;
    padding-top: 0px;
    position: relative;
    top: -100px;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {}

// media queries -at and down-
// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
  #buzz-app{
    .vue-slider-mark-label{
      display: none;
    }
    .vue-slider-mark:first-of-type .vue-slider-mark-label{
      display: block;
    }
    .vue-slider-mark:last-of-type .vue-slider-mark-label{
      display: block;
    }
  }
}

// Small devices (landscape phones, less than 768px)
@media (max-width: 767.98px) {
  #buzz-app{
    .vue-slider-mark-label{
      white-space: normal;
    }
  }
}

// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) {}

// Large devices (desktops, less than 1200px)
@media (max-width: 1199.98px) {}
</style>
